<template>
    <div class="innerMain">
      <div>
        <h3>통신판매번호</h3>
        <h4>2019-부산해운대-1297</h4>
      </div>
      <hr/>
      <div>
        <h3>사업자등록번호</h3>
        <h4>606-86-60246</h4>
      </div>
      <hr/>
      <div>
        <h3>신고현황</h3>
        <h4>통신판매업 신고</h4>
      </div>
      <hr/>
      <div>
        <h3>법인여부</h3>
        <h4>법인</h4>
      </div>
      <hr/>
      <div>
        <h3>상호</h3>
        <h4>주식회사 토노베이션</h4>
      </div>
      <hr/>
      <div>
        <h3>대표자명</h3>
        <h4>박용철</h4>
      </div>
      <hr/>
      <div>
        <h3>대표 전화번호</h3>
        <h4>1661-9068</h4>
      </div>
      <hr/>
      <div>
        <h3>판매방식</h3>
        <h4>인터넷/앱</h4>
      </div>
      <hr/>
      <div>
        <h3>취급품목</h3>
        <h4>종합몰</h4>
      </div>
      <hr/>
      <div>
        <h3>전자우편(E-mail)</h3>
        <h4>admin@tonovation.com</h4>
      </div>
      <hr/>
    </div>
</template>
<script>
export default {
  name: 'privacy1',
  data () {
    return {
    }
  },
  mounted () {
    console.log('mounted::', this.$options.name)
  },
  methods: {
  }
}
</script>

<style scoped>
.main {
   width: 100%;
   height: 100%;
   color:#e0e0e0;
   min-width:400px;
   margin:auto;
  }
  .innerMain{
    width:100%;
    height: -moz-calc(100vh - 100px);
    height:-webkit-calc(100vh - 100px);
    height:calc(100vh - 100px);
    display: inline-block;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/privacy/privacy4.vue